(() => {
  const loadImage = image => {
    if (image.dataset.lazySrcset) image.srcset = image.dataset.lazySrcset;
    if (image.dataset.lazySrc) image.src = image.dataset.lazySrc;
    delete image.dataset.lazySrc; delete image.dataset.lazySrcset;
  };
  const imageObserver = 'IntersectionObserver' in window ? new IntersectionObserver(entries => {
    entries.forEach(entry => {if (entry.isIntersecting) {loadImage(entry.target); imageObserver.unobserve(entry.target);}});
  }, {rootMargin: '240px 0px'}) : null;
  const init = (scope = document) => {
    scope.querySelectorAll('img[data-lazy-src]').forEach(image => imageObserver ? imageObserver.observe(image) : loadImage(image));
    scope.querySelectorAll('[data-bundle-builder]').forEach((builder) => {
      if (builder.dataset.initialized) return;
      builder.dataset.initialized = 'true';
      const offers = [...builder.querySelectorAll('[data-pack]')];
      const controls = [...builder.querySelectorAll('[data-flavor]')];
      const counts = new Map(controls.map((control) => [control.dataset.flavor, 0]));
      const add = builder.querySelector('[data-add-bundle]');
      const message = builder.querySelector('[data-message]');
      const mobileBar = builder.querySelector('[data-purchase-bar]');
      const mobileAction = builder.querySelector('[data-mobile-action]');
      const params = new URLSearchParams(window.location.search);
      let active = offers.find(offer => offer.dataset.pack === params.get('pack')) || offers.find(offer => offer.dataset.variant === params.get('variant')) || offers.find(offer => offer.dataset.pack === '3') || offers[0];
      if (counts.has(params.get('flavor'))) counts.set(params.get('flavor'), 1);
      let pending = false;
      const selectedTotal = () => [...counts.values()].reduce((sum, value) => sum + value, 0);
      const root = builder.dataset.root || '/';
      const money = (cents) => new Intl.NumberFormat(builder.dataset.locale || 'en-US', {style:'currency', currency:builder.dataset.currency || 'USD'}).format(cents / 100);
      const render = () => {
        const size = Number(active.dataset.pack);
        const total = selectedTotal();
        const allFlavors = builder.querySelector('[data-all-flavors]');
        if(allFlavors){allFlavors.hidden=size!==5;allFlavors.disabled=pending;}
        const clearFlavors = builder.querySelector('[data-clear-flavors]');
        if(clearFlavors)clearFlavors.disabled=pending || total===0;
        const arrival = builder.querySelector('[data-arrival-count]');
        if (arrival) arrival.textContent = `${size} ${size === 1 ? 'stick' : 'sticks'} in your order${size === 3 ? ' · includes 1 free' : size === 5 ? ' · includes 2 free' : ''}`;
        const priceNode = builder.querySelector('[data-bundle-total]');
        if (priceNode) priceNode.textContent = money(Number(active.dataset.price));
        const available = active.dataset.available === 'true' && /^\d+$/.test(active.dataset.variant);
        offers.forEach((offer) => {const selected = offer === active; offer.classList.toggle('is-selected', selected); offer.setAttribute('aria-pressed', String(selected)); offer.disabled = pending;});
        controls.forEach((control) => {const count = counts.get(control.dataset.flavor); control.classList.toggle('has-selection', count > 0); control.querySelector('output').value = count; control.querySelector('[data-change="-1"]').disabled = count === 0 || pending; control.querySelector('[data-change="1"]').disabled = total >= size || pending;});
        const flavorHeading = builder.querySelector('[data-flavor-heading]'); if (flavorHeading) flavorHeading.textContent = `Choose your ${size} ${size === 1 ? 'flavor' : 'flavors'}`;
        builder.querySelector('[data-counter]').textContent = `${total} of ${size} selected`;
        const selection = [...counts.entries()].filter(([, count]) => count).map(([flavor, count]) => `${count} × ${flavor}`).join(' · ');
        builder.querySelector('[data-summary]').textContent = selection ? `Your selection: ${selection}` : 'Choose your first flavor above.';
        add.disabled = pending || total !== size || !available;
        if (mobileBar) {
          builder.querySelector('[data-mobile-price]').textContent = money(Number(active.dataset.price));
          builder.querySelector('[data-mobile-progress]').textContent = `${size} ${size === 1 ? 'stick' : 'sticks'} · ${total}/${size} chosen`;
          mobileAction.disabled = pending || !available;
          mobileAction.textContent = pending ? 'Adding…' : !available ? 'Unavailable' : total === size ? 'Add to bag' : 'Choose flavors';
        }
        add.textContent = pending ? 'Adding to your bag…' : !available ? 'Currently unavailable' : total !== size ? `Choose ${size - total} more ${size - total === 1 ? 'flavor' : 'flavors'}` : `Add to bag — ${money(Number(active.dataset.price))}`;
      };
      offers.forEach((offer) => offer.addEventListener('click', () => {
        if (pending || offer === active) return;
        active = offer;
        // Keep the user's choices when increasing the bundle; ask them to reselect
        // when downsizing, rather than silently removing a chosen flavor.
        if (selectedTotal() > Number(active.dataset.pack)) {counts.forEach((_, key) => counts.set(key, 0)); message.textContent = `Choose ${active.dataset.pack} ${active.dataset.pack === '1' ? 'flavor' : 'flavors'} for this selection.`;} else {message.textContent = '';}
        render();
      }));
      controls.forEach((control) => control.querySelectorAll('[data-change]').forEach((button) => button.addEventListener('click', () => {
        if (pending) return;
        const flavor = control.dataset.flavor;
        const change = Number(button.dataset.change);
        if ((change > 0 && selectedTotal() >= Number(active.dataset.pack)) || (change < 0 && counts.get(flavor) === 0)) return;
        counts.set(flavor, counts.get(flavor) + change); message.textContent = ''; render();
      })));
      add.addEventListener('click', async () => {
        const size = Number(active.dataset.pack);
        if (pending || selectedTotal() !== size || active.dataset.available !== 'true' || !/^\d+$/.test(active.dataset.variant)) return;
        const properties = {};
        let slot = 0;
        for (const [flavor, count] of counts) for (let i = 0; i < count; i++) properties[`Stick ${++slot}`] = flavor;
        properties['Bundle'] = size === 1 ? 'Single stick · 1 flavor' : size === 3 ? 'Buy 2, get 1 free · 3 sticks total' : 'Buy 3, get 2 free · 5 sticks total';
        pending = true; message.textContent = ''; render();
        try {
          const response = await fetch(`${root}cart/add.js`, {method:'POST', credentials:'same-origin', headers:{'Content-Type':'application/json','Accept':'application/json'}, body:JSON.stringify({items:[{id:Number(active.dataset.variant),quantity:1,properties}]})});
          const result = await response.json();
          if (!response.ok) throw new Error(result.description || result.message || 'This bundle could not be added. Please try again.');
          window.location.assign(`${root}cart`);
        } catch (error) {message.textContent = error.message || 'Please check your connection and try again.'; pending = false; render();}
      });
      document.querySelectorAll('[data-guide-flavor]').forEach(link => {
        if (link.dataset.initialized) return;
        link.dataset.initialized = 'true';
        link.addEventListener('click', () => {
          const flavor = link.dataset.guideFlavor;
          if (!counts.has(flavor) || pending) return;
          if (selectedTotal() < Number(active.dataset.pack)) {
            counts.set(flavor, counts.get(flavor) + 1); message.textContent = `${flavor} added to your selection.`;
          } else {
            message.textContent = `Your selection is full. Remove a stick with the minus button to make room for ${flavor}.`;
          }
          render();
        });
      });
      if (mobileBar) {
        mobileBar.hidden = false;
        mobileAction.addEventListener('click', () => {
          if (selectedTotal() === Number(active.dataset.pack)) { add.click(); return; }
          const picker = builder.querySelector('.flavor-picker');
          picker.scrollIntoView({behavior: 'smooth', block: 'start'});
          const next = builder.querySelector('[data-change="1"]:not(:disabled)');
          if (next) next.focus({preventScroll: true});
        });
        new IntersectionObserver(entries => {
          mobileBar.hidden = entries[0].isIntersecting;
        }, {threshold: 0.1}).observe(add);
      }
      builder.querySelector('[data-all-flavors]')?.addEventListener('click', () => {
        if(pending || Number(active.dataset.pack)!==5)return;
        counts.forEach((_, key)=>counts.set(key,1));message.textContent='One of each flavor selected. Adjust any quantity below.';render();
      });
      builder.querySelector('[data-clear-flavors]')?.addEventListener('click', () => {
        if(pending)return;
        counts.forEach((_, key)=>counts.set(key,0));message.textContent='Selection cleared.';render();
      });
      builder.querySelector('[data-edit-flavors]')?.addEventListener('click', () => {
        builder.querySelector('.flavor-picker').scrollIntoView({behavior:'smooth',block:'start'});
        builder.querySelector('[data-change]:not(:disabled)')?.focus({preventScroll:true});
      });
      render();
    });
    scope.querySelectorAll('.purchase-gallery').forEach(gallery => {
      if (gallery.dataset.initialized) return;
      gallery.dataset.initialized = 'true';
      const thumbs = [...gallery.querySelectorAll('[data-gallery-thumb]')];
      let current = 0;
      const select = index => {
        current = (index + thumbs.length) % thumbs.length;
        const button = thumbs[current];
        const main = gallery.querySelector('[data-gallery-main]');
        const panel = gallery.querySelector('[data-gallery-video]');
        const isVideo = button.dataset.galleryType === 'video';
        main.hidden = isVideo;
        if (panel) {panel.hidden = !isVideo; if (!isVideo) panel.querySelectorAll('video').forEach(v=>v.pause());}
        if (!isVideo) {const image = button.querySelector('img'); main.srcset = image.dataset.fullSrcset || image.srcset; main.src = image.dataset.fullSrc || image.src; main.alt = button.dataset.name;}
        gallery.querySelector('[data-gallery-label]').textContent = button.dataset.name;
        const counter = gallery.querySelector('[data-gallery-count]'); if (counter) counter.textContent = `${current + 1} / ${thumbs.length}`;
        thumbs.forEach(b=>b.setAttribute('aria-pressed',String(b===button)));
      };
      thumbs.forEach((button,index)=>button.addEventListener('click',()=>select(index)));
      const stage = gallery.querySelector('[data-gallery-stage]');
      if (stage) {
        let touch;
        stage.addEventListener('touchstart',e=>{touch=e.touches[0];},{passive:true});
        stage.addEventListener('touchend',e=>{
          if (!touch || e.target.closest('video')) return;
          const dx=e.changedTouches[0].clientX-touch.clientX, dy=e.changedTouches[0].clientY-touch.clientY;
          if (Math.abs(dx)>60 && Math.abs(dx)>Math.abs(dy)*1.5) select(current+(dx<0?1:-1));
          touch=null;
        },{passive:true});
      }
    });
    scope.querySelectorAll('[data-flavor-scroll]').forEach(button => {
      if (button.dataset.initialized) return;
      button.dataset.initialized = 'true';
      button.addEventListener('click', () => {
        const isScene = button.hasAttribute('data-scene-scroll');
        const row = isScene ? button.closest('.pdp-life').querySelector('.pdp-scene-row') : button.closest('.pdp-flavors').querySelector('.pdp-flavor-guide');
        const card = row.querySelector('article');
        const distance = card.getBoundingClientRect().width + parseFloat(getComputedStyle(row).gap || 0);
        row.scrollBy({left: Number(isScene ? button.dataset.sceneScroll : button.dataset.flavorScroll) * distance, behavior: 'smooth'});
      });
    });
    scope.querySelectorAll('.pdp-life').forEach(section => {
      if (section.dataset.carouselReady) return;
      section.dataset.carouselReady = 'true';
      const row = section.querySelector('.pdp-scene-row');
      const toggle = section.querySelector('[data-scene-toggle]');
      const reduced = matchMedia('(prefers-reduced-motion: reduce)');
      let paused = reduced.matches, visible = false, hovered = false, timer;
      const update = () => {
        toggle.textContent = paused ? 'Play' : 'Pause';
        toggle.setAttribute('aria-label', paused ? 'Play scene slideshow' : 'Pause scene slideshow');
      };
      const step = direction => {
        const distance = row.querySelector('article').getBoundingClientRect().width + parseFloat(getComputedStyle(row).gap || 0);
        const max = row.scrollWidth - row.clientWidth;
        let left = row.scrollLeft + direction * distance;
        if (direction > 0 && row.scrollLeft >= max - 3) left = 0;
        if (direction < 0 && row.scrollLeft <= 3) left = max;
        row.scrollTo({left, behavior: reduced.matches ? 'instant' : 'smooth'});
      };
      toggle.addEventListener('click', () => {paused = !paused; update();});
      section.querySelectorAll('[data-scene-scroll]').forEach(button => button.addEventListener('click', () => {
        paused = true; update(); step(Number(button.dataset.sceneScroll));
      }));
      row.addEventListener('pointerdown', () => {paused = true; update();});
      row.addEventListener('keydown', event => {
        if (!['ArrowLeft','ArrowRight'].includes(event.key)) return;
        event.preventDefault(); paused = true; update(); step(event.key === 'ArrowRight' ? 1 : -1);
      });
      section.addEventListener('mouseenter', () => {hovered = true;});
      section.addEventListener('mouseleave', () => {hovered = false;});
      const observer = new IntersectionObserver(entries => {visible = entries[0].isIntersecting;});
      observer.observe(row);
      timer = setInterval(() => {
        if (!section.isConnected) {clearInterval(timer); observer.disconnect(); return;}
        if (!paused && visible && !hovered && !document.hidden && !section.contains(document.activeElement)) step(1);
      }, 5000);
      update();
    });
    scope.querySelectorAll('.mobile-menu a').forEach((link) => link.addEventListener('click', () => {link.closest('details').open = false;}));
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init()); else init();
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
